<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">To</span>
            <span class="text-danger">*</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input
              type="number"
              :state="receiverValidation"
              v-model="sendSMSForm.receiver"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">From</span>
            <span class="text-danger">*</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              type="number"
              :state="senderValidation"
              v-model="sendSMSForm.sender"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12">
          <p class="mt-3">
            <span class="h3">SMS</span>
            <span class="text-danger">*</span>
          </p>
          <b-form-textarea
            id="sms-content"
            v-model="sendSMSForm.content"
            :state="sendSMSForm.content.length <=160"
            placeholder="Enter SMS content to send"
            rows="3"
            :formatter="formatLength"
            required
          ></b-form-textarea>
          <p class="text-xs" >
            {{this.sendSMSForm.content.length}}/160
          </p>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="danger" title="Close"  v-on:click="modalClose()">
            Close
        </base-button>
        <base-button type="primary" title="Send" :disabled="validation" v-on:click="sendSMSSubmit" :loading="submitLoading">
            Send
        </base-button>
      </div>
    </b-form>
  </div>
</template>

<script>
  import searchDashboardService from "../../common/api-services/search-dashboard-service";

  export default {
    name: "Send-SMS",
    components: {},
    data() {
      return {
        sendSMSForm: {
          receiver: '',
          sender: '',
          content: ''
        },
        contentLength: 160,
        submitLoading: false
      }
    },
    mounted() {
      this.$root.$on('sendSMSModal', (event) => {
        this.sendSMSForm.receiver = event
      })
    },
    computed: {
      validation() {
        let validated = false;
        if (!this.smsValidation && this.senderValidation && this.receiverValidation) {
          validated = true
        }
        return !validated 
      },
      
      smsValidation() {
        return this.sendSMSForm.content.length > 160
      },

      senderValidation() {
        return String(this.sendSMSForm.sender).length === 11
      },

      receiverValidation() {
        return String(this.sendSMSForm.receiver).length === 11
      }
    },
    methods: {
      formatLength(event) {
        return String(event).substring(0, 160)
      },

      modalClose() {
        this.$bvModal.hide('send-sms')
      },

      sendSMSSubmit() {
        this.submitLoading = true;
        let {sender, receiver, content} = this.sendSMSForm;
        searchDashboardService.sendSMS(sender, receiver, content).then(res => {
          this.submitLoading = false;
          this.$bvModal.hide('send-sms');
          this.$toast.success(res.response)
        })
      },
    }
  }
</script>
